import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/arrow-left-eoi-request.svg'


const _hoisted_1 = { class: "customer__container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "row-form-column" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  key: 0,
  class: "error"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = { class: "form-group form-group--email" }
const _hoisted_10 = { class: "input-large input--email" }
const _hoisted_11 = { class: "row-form-column" }
const _hoisted_12 = {
  key: 0,
  class: "form-group"
}
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = {
  key: 1,
  class: "form-group"
}
const _hoisted_15 = {
  key: 0,
  class: "error"
}
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", {
      class: "customer__title customer__title--with-arrow",
      onClick: $setup.onBack
    }, [...(_cache[7] || (_cache[7] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1),
      _createElementVNode("span", null, "Edit Profile", -1)
    ]))]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "form-profile",
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", null, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "First Name", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input-large", { 'input--error': $setup.v$.firstName.$error }]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.firstName) = $event)),
                placeholder: "First Name"
              }, null, 2), [
                [_vModelText, $setup.form.firstName]
              ])
            ]),
            ($setup.v$.firstName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.v$.firstName.required.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", null, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Middle Name(s)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "input-large",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.middleName) = $event)),
                placeholder: "Middle Name(s)"
              }, null, 512), [
                [_vModelText, $setup.form.middleName]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "Last Name", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input-large", { 'input--error': $setup.v$.lastName.$error }]),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.lastName) = $event)),
                placeholder: "Last Name"
              }, null, 2), [
                [_vModelText, $setup.form.lastName]
              ])
            ]),
            ($setup.v$.lastName.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.v$.lastName.required.$message), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", null, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "Email", -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString($setup.form.email), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          ($setup.form.details)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "Postcode", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["input-large", { 'input--error': $setup.v$.details.postcode.$error }]),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.details.postcode) = $event)),
                  placeholder: "e.g. 2000",
                  maxlength: "4"
                }, null, 2), [
                  [_vModelText, $setup.form.details.postcode]
                ]),
                ($setup.v$.details.postcode.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.v$.details.postcode.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          ($setup.form.details)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("label", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "Address", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input-large", { 'input--error': $setup.v$.details.address.$error }]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.details.address) = $event)),
                    placeholder: "Address"
                  }, null, 2), [
                    [_vModelText, $setup.form.details.address]
                  ])
                ]),
                ($setup.v$.details.address.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.v$.details.address.required.$message), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", null, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "Phone Number", -1)),
              _createVNode($setup["Cleave"], {
                class: _normalizeClass(["input input-large", { 'input--error': $setup.v$.phone.$error }]),
                modelValue: $setup.form.phone,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.phone) = $event)),
                options: $setup.phoneNumberOption($setup.form.phone),
                placeholder: "0412 345 678"
              }, null, 8, ["modelValue", "options", "class"])
            ]),
            ($setup.v$.phone.$error)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString($setup.v$.phone.$errors[0]?.$message), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ], 32),
      _createElementVNode("div", { class: "form-controls" }, [
        _createElementVNode("button", {
          class: "button primary",
          onClick: $setup.submitForm
        }, "Save Changes"),
        _createElementVNode("button", {
          class: "button delete",
          onClick: $setup.onCancel
        }, "Cancel")
      ])
    ])
  ]))
}